import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { FAQ_ITEMS } from "../../constants";

class FAQ extends Component {
  buildSchema() {
    const { items } = this.props;
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map(({ question, answer }) => ({
        "@type": "Question",
        name: question,
        acceptedAnswer: {
          "@type": "Answer",
          text: answer,
        },
      })),
    };
  }

  renderFAQs() {
    const { items } = this.props;
    let rendered = items.map(({ question, answer }) => {
      return (
        <div key={`faq ${question}`} className="faq-item anim_piece">
          <h3 className="faq-question">{question}</h3>
          <p className="faq-answer">{answer}</p>
        </div>
      );
    });

    return rendered;
  }

  render() {
    return (
      <section id="faq">
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(this.buildSchema())}
          </script>
        </Helmet>
        <div className="container">
          <div className="row">
            <div className="col">
              <h2 className="anim_piece">Frequently Asked Questions</h2>
            </div>
          </div>
          <div className="row">
            <div className="col">{this.renderFAQs()}</div>
          </div>
        </div>
      </section>
    );
  }
}

FAQ.defaultProps = {
  items: FAQ_ITEMS,
};

export default FAQ;
